import { OptionDto } from "@/dtos";
import { TurnType } from "@/helpers/types/routes/turns/turn-type";

const types = [
    { value: parseInt(TurnType.NORMAL), label: 'Normal' },
    { value: parseInt(TurnType.RETAINER), label: 'Retén' },
    { value: parseInt(TurnType.RESERVE), label: 'Reserva' },
] as OptionDto[];

export const getTurnTypeOptions = (): OptionDto[] => {
    return types;
}

export const getTurnTypeOption = (value?: number): OptionDto => {
    return types.find((x) => x.value == value) ?? types[0];
}